import React, { useContext } from "react";

import GeneralPageContext from "../../templates/GeneralPageContext";
import { generateClassString as gcs } from "../../lib/helper/generateClassString";

import { isLightBackground, Background } from "../Background/Background";

import * as styles from "./component.module.less";
import { slugify } from "../../lib/helper/getAnchorNavData";
import { useAnchorNavVisibilitySensor } from "../../lib/hooks/useAnchorNavVisibilitySensor";

export const SectionContainer = ({
    background = "bg_white",
    children,
    sectionId,
    sectionClass,
    containerClass,
    mediaAlignRight = false,
    noPadding,
    noSpacing,
    fullWidth,
    reducedWidth,
    renderAs = "section",
    partialVisibility = null,
    ...additionalProps
}) => {
    const {
        layout: { reducedContentWidth, showAnchorNavigation }
    } = useContext(GeneralPageContext);

    const { sectionRef: ref, VisibilitySensor } =
        useAnchorNavVisibilitySensor(sectionId);

    const isReduced =
        (reducedWidth || reducedContentWidth) && reducedWidth !== "never";

    const isLightBg = isLightBackground(background);

    const sectionClassName = gcs(
        styles.section,
        sectionClass,
        [fullWidth, styles.fullWidth],
        [noSpacing, styles.sectionNoSpacing],
        [background === "bg_white", styles.white],
        [background === "bg_grey", styles.grey],
        [isLightBg, styles.light]
    );

    const containerClassName = gcs(
        styles.contentContainer,
        "content-element",
        containerClass,
        [isReduced, styles.reducedWidth],
        [noPadding, styles.containerNoPadding],
        [mediaAlignRight, styles.alignRight]
    );

    const SectionContent = (
        <>
            {isReduced && showAnchorNavigation ? (
                <div className={styles.offCenterLayout}>
                    <div className={containerClassName}>{children}</div>
                </div>
            ) : (
                <div className={containerClassName}>{children}</div>
            )}
            <Background type={background} />
        </>
    );

    return (
        <VisibilitySensor partialVisibility={partialVisibility}>
            {renderAs === "div" ? (
                <div
                    ref={ref}
                    className={sectionClassName}
                    id={slugify(sectionId ?? "")}
                    {...additionalProps}
                >
                    {SectionContent}
                </div>
            ) : (
                <section
                    ref={ref}
                    className={sectionClassName}
                    id={slugify(sectionId ?? "")}
                    {...additionalProps}
                >
                    {SectionContent}
                </section>
            )}
        </VisibilitySensor>
    );
};
